class AdpChartLegendItemController {
  constructor() {
    this.name = 'adpChartLegendItem';
  }
}

export default AdpChartLegendItemController;



// WEBPACK FOOTER //
// ./src/app/components/adpChartLegendItem/adpChartLegendItem.controller.js